import React, { Component, useEffect, useState } from 'react';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import Select from 'react-select';
import { toDate } from 'date-fns';
import SelectSearch, { fuzzySearch } from "react-select-search";
import DatePicker from 'react-date-picker';
import moment from 'moment';

import "../style/select-search.css";
import { isDisabled } from '@testing-library/user-event/dist/utils';
import FormCheckInput from 'react-bootstrap/esm/FormCheckInput';
import { Modal, Button } from 'react-bootstrap';
import TransportationPopup from './TransportationPopup';


export default function TpSearchRightFilterContent(props) {



    const [carriers, setCarriers] = useState([]);
    const [dropDownCarriers, setdropDownCarriers] = useState([]);


    const [divisionLoading, isDivisionLoading] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]);

    const LoadCarriers = async (selectedItems) => {
        debugger;

        isDivisionLoading(true);
        const defaultCarrier = {
            label: "--Select A Value--",
            value: 0,
        };

        const selectedItemsOptions = selectedItems.map((item) => ({
            label: item.carrierName,
            value: item.carrierKey,
        }));

        const newCarriers = [...carriers]; // Create a copy of the carriers state

        selectedItemsOptions.forEach((option) => {
            // Check if the carrierKey already exists in the carriers state
            const existingCarrier = newCarriers.find((carrier) => carrier.value === option.value);
            if (!existingCarrier) {
                // If the carrierKey doesn't exist, add the new option to the carriers array
                newCarriers.push(option);
            }
        });

        setCarriers(newCarriers); // Update the carriers state with the new options
        isDivisionLoading(false);
    };

    const LoadCarriersByName = async (inputValue) => {
        // debugger;
        isDivisionLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Carrier/GetCarriersByName/${inputValue}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                debugger;
                let carrierOptions = [];
                resp.map(carriers => {
                    debugger;
                    const carr = {
                        "value": carriers.carrierKey,
                        // "label": (
                        //     <>
                        //         <span title={carriers.carrierName}>{carriers.carrierName}</span>

                        //     </>
                        // )
                        "label": carriers.carrierName

                    }
                    carrierOptions = [...carrierOptions, carr];
                })
                setdropDownCarriers(carrierOptions)
            })
        isDivisionLoading(false);
        // setIsDisabled(props.isDisabled);
    }




    const LoadBills = async (e) => {
        debugger;
        const carriersValues = carriers.map((carrier) => carrier.value).join(",");
        e.preventDefault();
        if (carriersValues.length === 0) {
            document.getElementById("carrier-error").innerHTML = "Carrier is a Required Field, a selection must be made";
            document.getElementById("carrier-highlight").innerHTML = "*&nbsp&nbsp";
            return;
        }
        else {
            document.getElementById("carrier-error").innerHTML = "";
            document.getElementById("carrier-highlight").innerHTML = "";
        }

        debugger;
        props.onSearchClick(carriersValues);
    }

    useEffect(() => {
        // debugger;
        // LoadOwners();
        // LoadCarriers();
        // LoadCustomer();
        // const inputPstNoOfwk = document.querySelector('#pastnumofweek');
    }, [])

    const ClearFilter = async (e) => {
        // debugger;
        e.preventDefault();
        setCarriers([]);
    }

    const handleCarrierSelect = (e) => {
        const filteredOptions = e.filter(
            (option) => !carriers.some((carrier) => carrier.value === e.value)
        );

        setCarriers((prevCarriers) => [...prevCarriers, ...filteredOptions]);

        setCarriers(e);

        if (document.getElementById("carrier-error").innerHTML !== "") {
            document.getElementById("carrier-error").innerHTML = "";
            document.getElementById("carrier-highlight").innerHTML = "";
        }

    };

    const handleInputChange = (inputValue) => {
        // debugger;
        if (inputValue.trim().length > 4) {
            LoadCarriersByName(inputValue);
        }
        else {
            setdropDownCarriers([]);
        }
    };

    const handleTransportationPopCancel = () => {
        setIsShow(!isShow);
    };




    // Function to handle selected items from TransportationPopup
    const handleSelectedItems = (items) => {
        debugger;
        setSelectedItems(items);
        console.log(selectedItems);
        LoadCarriers(items);
        setIsShow(!isShow);
        if (document.getElementById("carrier-error").innerHTML !== "") {
            document.getElementById("carrier-error").innerHTML = "";
            document.getElementById("carrier-highlight").innerHTML = "";
        }

    };

    const handleRemoveCarrier = (removedOption) => {
        debugger;
        const updatedSelection = carriers.filter(
            (option) => option.value !== removedOption.value
        );
        setCarriers(updatedSelection);

    };


    const [isShow, setIsShow] = useState(false);

    const initModal = () => {
        return setIsShow(!false)
    }

    return (
        <>





            <div className="mb-2 form-field">
                <div id="carrier-error" className="text-danger"></div>
                <label><label id="carrier-highlight" className="text-danger"></label>Transportation Provider</label>
                <label id="carrier-highlight" className="text-danger">*</label>

                <span className='input-group-text ms-2' style={{ display: 'inline-block', padding: '0.125rem 0.45rem' }}
                    onClick={initModal}>
                    <i className='fa fa-search small'></i>
                </span>
                <div>
                    <div>
                    <Select
                        value={carriers}
                        isMulti
                        options={dropDownCarriers}
                        name="colors"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isClearable={true}
                        // value={selectedCarrier}
                        onChange={handleCarrierSelect}
                        onInputChange={handleInputChange}
                        components={{
                            MultiValueRemove: ({ innerProps, data }) => (
                                <span
                                    {...innerProps}
                                    onClick={() => handleRemoveCarrier(data)}
                                >
                                    &times;
                                </span>
                            )
                        }}
                        menuContainerStyle={{
                            maxHeight: '200px !important', // Set the maximum height of the menu container
                            overflowY: 'auto', // Enable vertical scrolling
                        }}
                    />

</div>
                    
                </div>
            </div>
            <div className="form-field mx-auto" style={{ width: "180px" }}>
                <button type="button" onClick={ClearFilter} className='btn btn-clear'>Clear</button>
                <button type="button" onClick={LoadBills} className='btn btn-filter ms-2'>Filter</button>
            </div>




            <Modal size='lg' show={isShow}>
                <div class="modal-header">
                    <p className="fw-bold" id="tpModalTitle">Administrative Transportation Search</p>
                    <i className='fa fa-close' onClick={() => setIsShow(!isShow)}>
                        <span aria-hidden="true"></span>
                    </i>
                </div>

                <Modal.Body>

                    <TransportationPopup onCancel={handleTransportationPopCancel} onSelectedItems={handleSelectedItems} />


                </Modal.Body>
                {/* <Modal.Footer className='text-center'>
                    <button type="button" class="btn btn-filter ms-2" >Search</button>
                    <button type="button" class="btn btn-filter ms-2">Select</button>
                    <button type="button" class="btn btn-clear" onClick={() => setIsShow(!isShow)}>Cancel</button>
                </Modal.Footer> */}
            </Modal>




        </>
    )
}
